import { Component, OnInit, Renderer2 } from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, Params } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AbstractComponent } from "./abstract/abstract.component";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { Router } from '@angular/router';
import { HeaderComponent } from './incs/header.component';

@Component({
    selector: 'kilowant-tou',
    templateUrl: '../../html/main-disclaimer.html',
    imports: [HeaderComponent]
})
export class DisclaimerComponent extends AbstractComponent {
  opened: number[] = [];

  constructor(
      router: Router, 
      route: ActivatedRoute, 
      analyticsService: AnalyticsService,
      generalService: GeneralService, 
      private renderer: Renderer2,
      dialog: MatDialog) {
       super(router, route, dialog, analyticsService, generalService);
  }

  ngOnInit(): void {
  }

  getBaseLink() {
    return this.router.url.split('#')[0];
  }

  ngOnDestroy() {
  }

  onClick() {
  }

  openClose(i: number): void {
    if (this.opened.includes(i)) {
      this.opened.splice(this.opened.indexOf(i), 1);
    } else {
      this.opened[this.opened.length] = i;
    }
  }
}
